import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, Link } from "react-router-dom";
// components
import { Row, Col, Form, Input, Button, Alert, Checkbox } from "antd";
// images
import loginImage from "assets/images/login.png";
import logo from "assets/images/bbps-logo.png";
import axios from "axios";
import Swal from "sweetalert2";
// actions
import { loginAction as login } from "redux/actions/auth";
import { getConfigAction as getConfig } from "redux/actions/config";

const Login = () => {
  const [mobile, setMobile] = useState();
  const [otp, setOtp] = useState();
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);

  const authUser = useSelector((state) => state.auth.authUser);
  console.log("authhhh", authUser);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (authUser) {
      const from = location.state?.from?.pathname || "/";
      navigate(from, { replace: true });
    }
  }, [authUser, navigate, location.state]);

  // useEffect(() => {
  //   console.log("authuserrrr",authUser);
  //   if (authUser) {
  //     const from = location.state?.from?.pathname || "/";

  //     dispatch(getConfig());
  //     // redirect to home
  //     navigate(from, { replace: true });
  //   }
  // }, [authUser]);

  const handleSendOtp = async () => {
    if (!mobile || mobile.length !== 10) {
      return Swal.fire(
        "Error",
        "Please enter a valid 10-digit mobile number",
        "error"
      );
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}login-send-otp`,
        { mobile }
      );
      if (res.data.status === 1) {
        setIsOtpSent(true);
        Swal.fire("Success", "OTP sent to your mobile number.", "success");
      } else {
        Swal.fire("Error", res.data.message || "Failed to send OTP", "error");
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message || "Failed to send OTP",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp) {
      return Swal.fire("Error", "Please enter the OTP", "error");
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}login-send-otp-verify`,
        {
          mobile,
          otp
        }
      );

      if (res.data.status === 1) {
        const { user: merchant, access_token } = res.data.data;
        dispatch(login({ merchant, access_token }));
        Swal.fire("Success", "Login successful!", "success");
      } else {
        Swal.fire("Error", res.data.message || "Invalid OTP", "error");
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message || "Verification failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };
  const onSubmit = () => {
    if (isOtpSent) {
      handleVerifyOtp();
    } else {
      handleSendOtp();
    }
  };

  return (
    <div className="Login_Page">
      <Row className="login-wrapper">
        <Col lg={12} md={10} sm={24} xs={24}>
          <img src={loginImage} alt="login-bg" className="Login_Left" />
        </Col>
        <Col lg={12} md={14} sm={24} xs={24}>
          <div className="login-form">
            <div className="logoo">
              <img src={logo} className="logo login_Logo" alt="logo" />
            </div>
            <h1>Login</h1>
            {isError && (
              <Alert
                message="Email or password is incorrect. Please try again."
                type="error"
              />
            )}
            <Form layout="vertical" onSubmit={onSubmit}>
              {/* <Form.Item
                label="Mobile"
                name="Mobile"
                rules={[{ required: true, message: "Please input your Mobile!" }]}
              >
                <Input className="login-form--input"
                
                
                />
              </Form.Item> */}
              <Form.Item
                label="Mobile"
                required
                validateStatus={mobile && mobile.length !== 10 ? "error" : ""}
                help={
                  mobile && mobile.length !== 10
                    ? "Please enter a valid 10-digit mobile number"
                    : ""
                }
              >
                <Input
                  placeholder="Enter mobile"
                  value={mobile}
                  maxLength={10}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => setMobile(e.target.value)}
                />
              </Form.Item>

              {/* <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: "Please input your password!" }]}
              >
                <Input.Password className="login-form--input" />
              </Form.Item> */}

              {/* <Row justify="space-between" align="middle" className="mb-16">
                <Link to="#">Forgot your password?</Link>
                <Checkbox>Keep me signed in</Checkbox>
              </Row> */}

              {/* <Button
                htmlType="submit"
                type="primary"
                className="login-form--button"
                loading={loading}
              >
                Login
              </Button> */}
              {isOtpSent && (
                <Form.Item label="Enter OTP" required>
                  <Input
                    placeholder="Enter OTP"
                    value={otp}
                    maxLength={6}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                </Form.Item>
              )}

              <Button
                type="primary"
                onClick={isOtpSent ? handleVerifyOtp : handleSendOtp}
                loading={loading}
                block
              >
                {isOtpSent ? "Verify OTP" : "Send OTP"}
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Login;
